import debug from 'debug';
import BaseComponent from 'Global/Shared/Components/BaseComponent/BaseComponent';

const log = debug('BurgerNavigation');

class BurgerNavigation extends BaseComponent {

	constructor(element) {
		super(element);

		this.closeMenuEvent = this.closeMenuHandler.bind(this);
		this.toggleMenuEvent = this.toggleMenuHandler.bind(this);

		this.initialize();
	}

	closeMenuHandler() {
		this.element.classList.remove(this.activeClass);
		this.body.removeEventListener('click', this.closeMenuEvent, false);
	}

	eventListeners() {
		this.dom.trigger.addEventListener('click', this.toggleMenuEvent, false);	
	}

	initialize() {
		this.activeClass = 'nav-is-open';
		this.body = document.querySelector('body');

		this.initDomCache();
		this.eventListeners();
	}

	sleep(ms) {
		return new Promise(resolve => setTimeout(resolve, ms));
	}

	async toggleMenuHandler(event) {
		event.preventDefault();

		if (this.element.classList.contains(this.activeClass)) {
			this.element.classList.remove(this.activeClass);
			return;
		}

		this.element.classList.add(this.activeClass);

		// Setup timeout to close menu when clicking somewhere on the page
		await this.sleep(500);
		this.body.addEventListener('click', this.closeMenuEvent, false);
	}
}

export default BurgerNavigation;
